var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-mealtime-slot",on:{"click":function($event){$event.stopPropagation();return (function () {
      return;
    })($event)}}},[_c('h4',[_vm._v(_vm._s(_vm.$t('calender.lblNothingSchedule'))+" "+_vm._s(this.mealtime)+".")]),_c('BaseButton',{attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return (function () {
        _vm.$emit('show-recipes');
      })($event)}}},[_c('BaseIcon',{staticClass:"icon-add-dish",attrs:{"name":"plus"}}),_vm._v(_vm._s(_vm.$t('calender.lblAddRecipe'))+"\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }